<div class="video">
  <iframe [src]="videoUrl" frameborder="0" allow="fullscreen; accelerometer; autoplay; encrypted-media; gyroscope;" height="100%" width="100%"></iframe>
</div>
